import apiHandler, { resultParser } from "../../../utils/api";

export async function userLogin(data) {
    return apiHandler.post('/api/users/login', data).then(resultParser)
}
